/* eslint-disable */
// Disalin otomatis dari public/memories.html (abstract art shapes Line Up) - jaga tetap sama.
function poly(n,ro,ri,rot){var d='';for(var k=0;k<n*2;k++){var r=k%2?ri:ro,a=(Math.PI*k/n)+(rot||0);d+=(k?'L':'M')+(50+r*Math.cos(a)).toFixed(1)+' '+(50+r*Math.sin(a)).toFixed(1);}return d+'Z';}
function scallop(n,r,amp){var d='';for(var k=0;k<=72;k++){var a=2*Math.PI*k/72,rr=r+amp*Math.sin(n*a);d+=(k?'L':'M')+(50+rr*Math.cos(a)).toFixed(1)+' '+(50+rr*Math.sin(a)).toFixed(1);}return d+'Z';}
var SHAPES=[
  'M50 4C73 1 97 19 95 45C94 71 79 97 51 96C25 96 3 79 5 51C6 25 25 6 50 4Z',
  'M13 96L13 46C13 22 30 5 50 5C70 5 87 22 87 46L87 96Z',
  poly(12,47,34,-Math.PI/2),
  scallop(9,42,5),
  'M8 18L60 4L96 32L88 84L38 96L4 68Z',
  'M8 92C8 38 38 8 92 8C92 62 62 92 8 92Z',
  'M50 3L97 50L50 97L3 50Z',
  'M6 30C6 14 18 6 34 10L74 4C90 4 96 16 94 32L90 70C92 88 80 96 64 94L28 96C12 96 4 86 6 70Z'
  ];
export const LINEUP_SHAPES = SHAPES;
// Homepage mengurutkan lineup aktif berdasarkan nama, shape = SHAPES[index % SHAPES.length]
export function lineupShapeIndex(entry, entries) {
  const list = (entries || []).filter((e) => e.active !== false).slice().sort((a, b) => String(a.name || '').localeCompare(String(b.name || ''), 'id'));
  const i = list.findIndex((e) => e.id === entry.id);
  return i < 0 ? 0 : i % SHAPES.length;
}
